import React from "react";
import { Col, Image, Row, Stack } from "react-bootstrap";
import logo from "../../assets/divertidogs_white.jpeg";

export const LoadingSection = () => {
  return (
    <Row className="justify-content-center">
      <Col className="col-8 justify-content-center">
        <Stack>
          <Image src={logo} className="img-fluid"></Image>
          <Row className="text-center">
            <h4>Procesando...</h4>
          </Row>
        </Stack>
      </Col>
    </Row>
  );
};
